import React from 'react';
import { useFormContext } from 'react-hook-form';

import { ScreenAboutLookFemale } from './AboutLookFemale';
import { ScreenAboutLookMale } from './AboutLookMale';

import type { LayoutDataType } from '../../types';

export const ScreenAboutLook: React.FC = () => {
  const form = useFormContext<LayoutDataType>();
  const gender = form.watch('gender');

  if (gender === 'male') {
    return <ScreenAboutLookMale />;
  }

  return <ScreenAboutLookFemale />;
};
